module.exports = __webpack_public_path__ + "media/images/browsers/camino-b6c1cdf742f4d601af01fde608c1743f.svg";